import { Routes, Route, Navigate } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import CourseAssignmentManagerRoute from '@BUP/routes/course-assignment-manager'
import CourseAssignmentPreferencesPage from '@BUP/pages/Data/courseAssignment/preferences'
import CourseAssignmentPeriodDashboardPage from '@BUP/pages/Data/courseAssignment/period'
import CourseAssignmentResultsPage from '@BUP/pages/Data/courseAssignment/results'
import CourseAssignmentResponsesPage from '@BUP/pages/Data/courseAssignment/responses'
import CourseAssignmentPeriodsPage from '@BUP/pages/Data/courseAssignment/periods'

const CourseAssignmentNavigation = () => {
  return (
    <Routes>
      <Route
        path='preferences'
        element={
          <RoleRoute name='CourseAssignmentPreferencesPage'>
            <CourseAssignmentPreferencesPage />
          </RoleRoute>
        }
      />
      <Route
        path='period'
        element={
          <RoleRoute name='CourseAssignmentPeriodDashboardPage'>
            <CourseAssignmentManagerRoute>
              <CourseAssignmentPeriodDashboardPage />
            </CourseAssignmentManagerRoute>
          </RoleRoute>
        }
      />
      <Route
        path='periods'
        element={
          <RoleRoute name='CourseAssignmentPeriodsPage'>
            <CourseAssignmentManagerRoute>
              <CourseAssignmentPeriodsPage />
            </CourseAssignmentManagerRoute>
          </RoleRoute>
        }
      />
      <Route
        path='results'
        element={
          <RoleRoute name='CourseAssignmentResultsPage'>
            <CourseAssignmentManagerRoute>
              <CourseAssignmentResultsPage />
            </CourseAssignmentManagerRoute>
          </RoleRoute>
        }
      />
      <Route
        path='responses'
        element={
          <RoleRoute name='CourseAssignmentResponsesPage'>
            <CourseAssignmentManagerRoute>
              <CourseAssignmentResponsesPage />
            </CourseAssignmentManagerRoute>
          </RoleRoute>
        }
      />
      {/* Role-safe, unlike redirecting to a fixed sub-route: 'preferences' is STUDENT-only
          (rbac/index.js), so a COUNSELOR landing here via a stale link/typo would get bounced to
          NotAllowedPage instead of their own dashboard. Mirrors SociogramNavigation's own
          catch-all for the same reason. */}
      <Route
        path='*'
        element={<Navigate to='/' />}
      />
    </Routes>
  )
}

export default CourseAssignmentNavigation
